import { render, staticRenderFns } from "./tutorial-detail.vue?vue&type=template&id=094836d6&scoped=true"
import script from "./tutorial-detail.vue?vue&type=script&lang=js"
export * from "./tutorial-detail.vue?vue&type=script&lang=js"
import style0 from "./tutorial-detail.vue?vue&type=style&index=0&id=094836d6&prod&scoped=true&lang=css"
import style1 from "./tutorial-detail.vue?vue&type=style&index=1&id=094836d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094836d6",
  null
  
)

export default component.exports